<template>
  <div class="Details">
    <div class="title">
      <span
        @click="backs"
        style="cursor: pointer; color: #4587ff; margin-right: 20px"
        ><i class="el-icon-arrow-left"></i>返回</span
      >
      {{ pageTit }}执业申请
    </div>
    <div class="centent_box">
      <div class="target_big_box" v-if="detailsData.target">
        <div class="target_img_box">
          <img :src="wqUrl + 'practice_objective_map.png'" mode="" />
          {{ detailsData.target }}
        </div>
        <div>{{ detailsData.targetDesc }}</div>
      </div>

      <div class="target_big_box" v-if="detailsData.condition">
        <div class="target_img_box">
          <img :src="wqUrl + 'occupational_conditions.png'" mode="" />
          {{ detailsData.condition }}
        </div>
        <div>{{ detailsData.conditionDesc }}</div>
      </div>

      <div
        class="prompt_warn"
        v-if="enterpriseAuthentication == 1"
        @click="oneVisible = true"
      >
        {{
          isView
            ? `${pageTit}执业，企业营业执照信息`
            : `申请${pageTit}执业，需录入企业营业执照信息`
        }}
        <span v-if="!isView" style="color: #6a93ff; margin-left: 10px">
          {{
            enterpriseCertification || (!isView && isEdit)
              ? '修改执照信息'
              : '填写执照信息'
          }}
        </span>
        <div v-else style="color: #6a93ff; margin-left: 10px">执照信息</div>
      </div>

      <div v-for="(el, i) in templateList" :key="i">
        <div
          class="select_box"
          v-if="el.type === 'upload'"
          @click="!isView ? clickTemplate(el, i) : null"
        >
          <div class="" style="">
            <span style="color: #eb3828; margin-right: 7px" v-if="el.required">
              *
            </span>
            {{ el.title }}
            <span
              style="
                color: #636363;
                font-size: 13px;
                font-weight: 200;
                margin-left: 5px;
              "
              v-if="el.tips"
            >
              （{{ el.tips }}）
            </span>
          </div>
          <div v-if="!isView">
            <div
              class="plusBox"
              v-if="
                (el.number > 1 && el.value.length < el.number) ||
                (el.number === 1 && !el.value)
              "
            >
              <i class="el-icon-plus"></i>
              <div style="margin: 0 0 0 5px; color: #326afb">上传</div>
            </div>
            <div v-else>
              <div style="color: #326afb">已上传</div>
            </div>
          </div>
        </div>

        <div
          class="select_box"
          v-if="el.type === 'select'"
          @click="!isView ? clickTemplate(el, i) : null"
        >
          <div class="" style="">
            <span style="color: #eb3828; margin-right: 7px">*</span>
            {{ el.title }}
            <span
              style="
                color: #636363;
                font-size: 13px;
                font-weight: 200;
                margin-left: 5px;
              "
              v-if="el.tips"
            >
              （{{ el.tips }}）
            </span>
          </div>
          <div class="cascaderCl" v-if="!isView">
            <div
              v-if="
                (el.number > 1 && el.value.length < el.number) ||
                (el.number === 1 && !el.value)
              "
            >
              <span style="margin-right: 10px">请选择</span>
              <i class="el-icon-arrow-down"></i>
              <el-cascader
                :options="castlist"
                :props="{
                  value: 'text',
                  label: 'text',
                }"
                @change="handleChange"
              >
              </el-cascader>
            </div>
            <div v-else>
              <div style="color: #326afb">已选择</div>
            </div>
          </div>
        </div>
        <div
          class=""
          style="margin-bottom: 10px"
          v-if="!Array.isArray(el.value) && el.value"
        >
          <div class="select_tow_box">
            <img
              v-if="el.secondary === 'img'"
              @click="clickImg(el.value)"
              :src="el.value"
              mode="widthFix"
              style="height: 40px"
            />

            <div v-if="el.secondary === 'doc'">{{ item.name }}</div>
            <i
              v-if="!isView"
              class="el-icon-close"
              @click.stop="deData(el, ind)"
            ></i>
          </div>
        </div>
        <div
          class=""
          style="margin-bottom: 10px"
          v-if="Array.isArray(el.value) && el.value.length > 0"
        >
          <div
            class="select_tow_box"
            v-for="(item, ind) in el.value"
            :key="ind"
          >
            <div @click="downFile(item.path, item.name)">{{ item.name }}</div>
            <i
              v-if="!isView"
              class="el-icon-close"
              @click.stop="deData(el, ind)"
            ></i>
          </div>
        </div>
      </div>

      <div class="" style="margin-bottom: 10px">
        <div class="select_box" style="margin-bottom: 5px">
          <div class="" style="">
            <span style="color: #eb3828; margin-right: 7px">*</span>
            执业保障金
            <div
              style="color: #636363; font-size: 13px; font-weight: 200"
            ></div>
          </div>
          <div class="" style="color: #eb3828; font-size: 15px">
            <div style="margin-right: 0px; font-size: 12px">￥</div>
            {{ price }}
          </div>
        </div>
        <div class="subtitle_two" style="">终止执业时全额退还</div>
      </div>

      <div class="ask_task">
        <div class="">附注说明</div>
        <div class="textarea_box">
          <textarea
            v-model="annotations"
            :disabled="isView"
            style="border: none; height: 60px; width: 100%"
            placeholder="请输入附注说明"
            placeholder-style="color:#999;font-size:15px;"
            :maxlength="255"
          ></textarea>
        </div>
      </div>

      <div class="footer_box" v-if="!isView && !isEdit">
        <div class="operate_but">
          <div class="apply_but clickdiv" @click="backs()">取消</div>

          <div class="click_but clickdiv" @click="submitData(0)">提交申请</div>
        </div>
      </div>
      <!-- <div class="footer_box" v-if="isView || (!isView && isEdit)">
        <div class="operate_but">
          <div class="apply_but clickdiv" @click="editClick()">
            {{ !isView && isEdit ? '确定' : '修改' }}
          </div>
          <div
            style="margin: 0 10px"
            class="apply_but clickdiv"
            @click="logOff()"
          >
            注销执业
          </div>
        </div>
      </div> -->
    </div>
    <!-- 企业认证 -->
    <el-dialog
      title="企业认证"
      top="5vh"
      :visible.sync="oneVisible"
      width="30%"
    >
      <div>
        <div class="content_box">
          <div class="img_box">
            <div class="title">上传营业执照</div>
            <div
              class="upload_box"
              :style="{
                alignItems: enterpriseObj.businessLicense ? 'center' : '',
              }"
              @click="$refs.filesi.click()"
            >
              <img
                v-if="enterpriseObj.businessLicense"
                style="margin-top: 0; width: 80%; height: 80%"
                :src="enterpriseObj.businessLicense"
                mode="aspectFill"
              />
              <img
                v-else
                :src="wqUrl + 'certificationPage_renz2.png'"
                mode="aspectFill"
              />
              <div v-if="!enterpriseObj.businessLicense" class="btn">
                上传/拍摄正面
              </div>
            </div>
          </div>
          <div class="input_box" style="margin-top: 35px">
            <span style="font-weight: 600"
              ><span style="color: red; margin-right: 5px">*</span>名称</span
            >
            <input
              :disabled="isView"
              type="span"
              v-model="enterpriseObj.enterpriseName"
              placeholder="请输入名称"
              :maxlength="30"
            />
          </div>
          <div class="input_box">
            <span style="font-weight: 600"
              ><span style="color: red; margin-right: 5px">*</span>类型</span
            >
            <input
              :disabled="isView"
              type="span"
              v-model="enterpriseObj.enterpriseType"
              placeholder="请输入类型"
              :maxlength="30"
            />
          </div>
          <div class="input_box">
            <span style="font-weight: 600"
              ><span style="color: red; margin-right: 5px">*</span>住所</span
            >
            <input
              :disabled="isView"
              type="span"
              v-model="enterpriseObj.enterpriseAddress"
              placeholder="请输入住所"
              :maxlength="30"
            />
          </div>
          <div class="input_box">
            <span style="font-weight: 600"
              ><span style="color: red; margin-right: 5px">*</span
              >法定代表人</span
            >
            <input
              :disabled="isView"
              type="span"
              v-model="enterpriseObj.enterpriseLegalPerson"
              placeholder="请输入法定代表人"
              :maxlength="10"
            />
          </div>
          <div class="input_box">
            <span style="font-weight: 600"
              ><span style="color: red; margin-right: 5px">*</span
              >营业期限</span
            >
            <input
              :disabled="isView"
              type="span"
              v-model="enterpriseObj.enterpriseValidityPeriod"
              placeholder="请输入营业期限"
              :maxlength="30"
            />
          </div>
          <div class="input_box">
            <span style="font-weight: 600"
              ><span style="color: red; margin-right: 5px">*</span
              >证照编号</span
            >
            <input
              :disabled="isView"
              type="span"
              v-model="enterpriseObj.enterpriseIdNumber"
              placeholder="请输入证照编号"
              :maxlength="30"
            />
          </div>
          <div class="input_box">
            <span style="font-weight: 600"
              ><span style="color: red; margin-right: 5px">*</span
              >社会信用代码</span
            >
            <input
              :disabled="isView"
              type="span"
              v-model="enterpriseObj.enterpriseSocialCreditCode"
              placeholder="请输入社会信用代码"
              :maxlength="18"
            />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="!isView || isEdit">
        <el-button @click="oneVisible = false">取 消</el-button>
        <el-button type="primary" @click="Certification()">提交</el-button>
      </span>
    </el-dialog>
    <!-- 支付 -->
    <!-- 扫码支付 -->
    <el-dialog title="扫码支付" :visible.sync="payVisible" class="payment">
      <div class="content">
        <div class="notes">请使用微信扫码下方二维码完成支付</div>
        <div class="imgBox">
          <img :src="payimg" alt="" />
        </div>
      </div>
    </el-dialog>

    <!-- 上传营业执照 -->
    <input
      type="file"
      accept="image/*"
      style="display: none"
      @change="uploadgonsi"
      ref="filesi"
    />
    <!-- 上传图片 -->
    <input
      type="file"
      accept="image/*"
      style="display: none"
      @change="uploadChecking"
      ref="imgfile"
    />
    <!-- 上传文件 -->
    <input type="file" style="display: none" @change="uploadFile" ref="files" />
  </div>
</template>

<script>
import { getarr } from 'utils/addr.js'
import qs from 'qs'
import {
  AddApplyPracticing,
  getNewApplicantList,
  ossUpload,
  enterpriseCertification,
  orderPayment,
  payOrderQuery,
  getServicesPracticeInfo,
} from 'api/professionServer'
const getarrList = getarr()
export default {
  props: ['optId'],
  watch: {
    optId: {
      handler(newVal, oldVal) {
        this.getNewApplicantList()
      },
      deep: true,
    },
  },
  created() {
    if (this.optId) {
      this.getNewApplicantList()
      this.getServicesPracticeInfo()
    }
  },
  data() {
    return {
      payVisible: false, //支付二维码
      payimg: '',
      enterpriseObj: {
        businessLicense: '', //执照链接
        enterpriseName: '', //单位名称
        enterpriseType: '', //类型
        enterpriseAddress: '', //地址
        enterpriseLegalPerson: '', //法人
        enterpriseValidityPeriod: '', //有效期
        enterpriseIdNumber: '', //证件号
        enterpriseSocialCreditCode: '', //信用代码
      },
      // 企业认证弹框
      oneVisible: false,
      castlist: getarrList,
      complete: false,
      enterpriseCertification: null,
      price: 0,
      pageTit: '律师', //  页面标题
      select_val: false, // 是否勾选合同
      isEdit: false,
      isView: false,
      annotations: '',
      templateList: [],
      gid: '',
      enterpriseAuthentication: 0, //是否需要营业执照
      detailsData: {
        target: '',
      },
      xz_index: '',
      cityShow: '',

      wqUrl:
        'https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/',
    }
  },
  methods: {
    // 企业认证提交
    async Certification() {
      if (!this.enterpriseObj.businessLicense) {
        this.$message.error('请上传营业执照')

        return
      }
      if (this.isPractice || this.isEdit) {
        if (
          !this.enterpriseObj.enterpriseName ||
          !this.enterpriseObj.enterpriseType ||
          !this.enterpriseObj.enterpriseAddress ||
          !this.enterpriseObj.enterpriseLegalPerson ||
          !this.enterpriseObj.enterpriseValidityPeriod ||
          !this.enterpriseObj.enterpriseIdNumber ||
          !this.enterpriseObj.enterpriseSocialCreditCode
        ) {
          this.$message.error('请将信息填写完整')

          return
        }
        //  this.$store.commit("",this.enterpriseObj).enterpriseCertification =
        this.$message.success('提交成功')

        // this.back()
        return
      }
      let res = await enterpriseCertification(qs.stringify(this.enterpriseObj))
      if (res.code == 415) {
        this.$message.error(res.data)

        return
      }
      if (res.code !== 200) {
        this.$message.error(res.message)
        return
      }
      this.$message.success('提交成功')
      this.getNewApplicantList()
      this.oneVisible = false
    },

    // 提交
    async submitData(type) {
      let userData = JSON.parse(localStorage.getItem('wqUserInfo'))
      console.log(userData)
      let obj = {}
      let str = ''
      let is = false
      this.templateList.forEach((el) => {
        if (
          (!el.value || el.value.length < 1) &&
          el.required &&
          type !== 6 &&
          type !== 5
        ) {
          this.$message.error('请将资料补充完整')
          is = true
          return
        }

        if (el.fieldName === 'location') {
          if (el.value[1]?.name && el.value[0].name === el.value[1].name) {
            this.$message.error('执业地不能重复选择')
            is = true
            return
          }
          el.value.forEach((it, i) => {
            if (i === el.value.length - 1) {
              str += it.name
            } else {
              str += it.name + ','
            }
          })
        } else {
          obj[el.fieldName] = el.value
        }
      })

      if (is) return

      obj.remark = this.annotations
      let opt = {
        actionType: type,
        applicantName: userData.realName || userData.nickName,
        ensureMoney: this.price,
        typeId: this.optId,
        practiceLocation: str,
        configJson: JSON.stringify(obj),
      }
      if (type == 6) opt.id = this.gid
      if (this.enterpriseCertification) {
        opt = {
          ...opt,
          businessLicenseBean: {
            ...this.enterpriseCertification,
          },
        }
      }
      if (type === 0) {
        this.complete = true
      }
      let res = await AddApplyPracticing(opt)
      this.complete = false
      if (res.code == 415) {
        this.$message.error('请录入企业营业执照信息')
      }
      if (res.code !== 200) return
      this.isContainer = false
      if (type === 0) {
        this.$message.success('提交成功')
        this.orderPayment(res.data)
      } else if (type === 6) {
        this.$message.success('保存成功')
      } else if (type === 4) {
        this.$message.success('修改成功')
      } else if (type === 5) {
        this.$message.success('注销成功')
      }
    },
    // 支付
    async orderPayment(orderId) {
      let opt = {
        applicationTpye: this.$store.state.publicType,
        openId: '',
        orderId: orderId,
        wayCode: 'WX_NATIVE',
      }

      let res = await orderPayment(opt)
      if (res.code !== 200) return
      this.payVisible = true
      this.payimg = res.data.payData
      this.payOrderQuery(res.data.payOrderId)
      let timer = setInterval(() => {
        this.payOrderQuery(res.data.payOrderId, timer)
      }, 3000)
    },
    // 订单支付状态查询
    async payOrderQuery(id, timer) {
      let res = await payOrderQuery({
        payOrderId: id,
      })
      if (res.code !== 200) return
      clearInterval(timer)
      this.payVisible = false
      this.backs()
      this.$emit('getNewApplicantList')
      this.$emit('userPracticing')
    },
    // 选择
    handleChange(value) {
      let city = value[0] + '/' + value[1]
      console.log(city)
      let i = this.xz_index
      if (Array.isArray(this.templateList[i].value)) {
        this.templateList[i].value.push({
          name: city,
        })
      } else {
        this.templateList[i].value = city
      }
    },
    // 删除选项
    deData(item, i) {
      if (item.number > 1) {
        item.value.splice(i, 1)
      } else {
        item.value = ''
      }
      this.templateList = [...this.templateList]
    },
    async uploadFile(e) {
      let file = e.target.files[0]
      let form = new FormData()
      form.append('file', file)
      form.append('fileName', file.name)
      const res = await ossUpload(form)
      if (res.code == 200) {
        let i = this.xz_index
        this.templateList[i].value.push({
          name: file.name,
          path: res.data,
        })
        this.templateList = [...this.templateList]
      }
    },
    // 上传
    async uploadgonsi(e) {
      let file = e.target.files[0]
      let form = new FormData()
      form.append('file', file)
      form.append('file_name', file.name)
      const res = await ossUpload(form)
      if (res.code == 200) {
        this.enterpriseObj.businessLicense = res.data
      }
    },
    // 上传
    async uploadChecking(e) {
      let file = e.target.files[0]
      let form = new FormData()
      form.append('file', file)
      form.append('file_name', file.name)
      const res = await ossUpload(form)
      if (res.code == 200) {
        let i = this.xz_index
        this.templateList[i].value = res.data
        this.templateList = [...this.templateList]
      }
    },
    // 点击模板
    clickTemplate(item, i) {
      console.log(item)
      this.xz_index = i
      if (item.type === 'select') {
        if (Array.isArray(item.value)) {
          if (item.value.length < item.number) this.cityShow = true
          return
        }

        this.cityShow = true
        return
      } else if (item.type === 'upload') {
        if (item.secondary === 'img' && item.number <= 1) {
          if (item.value) return
          this.$refs.imgfile.click()
        } else {
          if (item.value.length >= 3) return
          this.$refs.files.click()
        }
      }
    },
    backs() {
      this.$emit('backs')
    },
    async getNewApplicantList() {
      let res = await getNewApplicantList({
        typeId: this.optId,
      })
      if (res.code !== 200) return
      let data = res.data[0]
      this.id = data.typeId
      this.gid = data.id
      this.detailsData = JSON.parse(data.templateJson)
      this.pageTit = data.typeName
      this.enterpriseAuthentication = data.enterpriseAuthentication
      this.templateList = this.detailsData.template
      this.price = data.practiceEnsureMoney
      this.templateList.forEach((el) => {
        if (el.number > 1) {
          el.value = []
        } else {
          el.value = ''
        }
      })

      // 只查看不修改
      // if (opt.isView) {
      // 	this.isView = true
      // 	this.isContainer = false
      // 	this.getServicesPracticeInfo()
      // } else {
      // 	this.getServicesDraft()
      // }
    },
    async getServicesPracticeInfo() {
      let res = await getServicesPracticeInfo({
        typeId: this.optId,
      })
      if (res.code !== 200) return
      this.isEdit = !this.isEdit
      this.enterprise = {
        businessLicense: res.data.businessLicense,
        enterpriseAddress: res.data.enterpriseAddress,
        enterpriseIdNumber: res.data.enterpriseIdNumber,
        enterpriseLegalPerson: res.data.enterpriseLegalPerson,
        enterpriseName: res.data.enterpriseName,
        enterpriseSocialCreditCode: res.data.enterpriseSocialCreditCode,
        enterpriseType: res.data.enterpriseType,
        enterpriseValidityPeriod: res.data.enterpriseValidityPeriod,
      }
      this.enterpriseCertification = {
        ...this.enterprise,
      }

      this.dataProcessing(res.data)
    },
    // 数据处理函数
    dataProcessing(data) {
      let { practiceLocation, configJson, businessLicenseBean } = data
      let configObj = JSON.parse(configJson)
      this.templateList.forEach((el) => {
        if (el.fieldName === 'location' && practiceLocation) {
          practiceLocation.split(',').forEach((item) => {
            el.value.push({
              name: item,
            })
          })
        }

        Object.keys(configObj).forEach((key) => {
          if (key === el.fieldName) {
            el.value = configObj[key]
          }
        })

        this.annotations = configObj.remark || ''
      })
      this.templateList = [...this.templateList]
    },
  },
}
</script>

<style lang="scss" scoped>
.Details {
  height: 680px;
  overflow-y: auto;
  .title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #222222;
    flex: 1;
  }
  .centent_box {
    width: 100%;
    min-height: 15px;
    border-radius: 10px 10px 0 0;
    background-color: #fff;
    padding: 10px 10px calc(env(safe-area-inset-bottom) + 10px);
    box-sizing: border-box;
  }
  .target_big_box {
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
    background: #f0f4ff;
    border-radius: 10px;
    margin-bottom: 10px;

    .target_img_box {
      display: flex;
      align-items: center;
      font-size: 15px;
      font-weight: bold;
      color: #326afb;
      margin-bottom: 10px;

      > img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }

    > div {
      font-size: 14px;
      color: #333333;
    }
  }
  .select_box {
    position: relative;
    width: 100%;
    min-height: 50px;
    background: #f7f8fa;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
    align-items: center;
    box-sizing: border-box;
    margin-bottom: 5px;
    .cascaderCl {
      .el-cascader {
        position: absolute;
        top: 0;
        right: 0;
        opacity: 0;
      }
    }
    .plusBox {
      cursor: pointer;
      display: flex;
      align-items: center;
      color: #326afb;
    }
    > div:first-child {
      font-weight: 600;
      font-size: 15px;
      color: #333;
    }

    > div:last-child {
      font-size: 15px;
      color: #333333;
      display: flex;
      align-items: center;
    }
  }
  .subtitle_two {
    color: #999999;
    font-size: 13px;
    padding-left: 10px;
    box-sizing: border-box;
  }

  .ask_task {
    width: 100%;
    min-height: 105px;
    background: #f7f8fa;
    border-radius: 10px;
    padding: 15px 15px 5px;
    box-sizing: border-box;
    margin-bottom: 10px;

    > div:first-child {
      font-weight: 600;
      font-size: 15px;
      color: #333;
    }

    .textarea_box {
      width: 100%;

      margin-top: 10px;
      textarea {
        background: #f7f8fa;
      }
    }
  }

  .footer_box {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;

    .operate_but {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 15px;

      > div {
        width: 49%;
        height: 50px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        font-size: 16px;
      }

      .apply_but {
        border: 1px solid #326afb;
        background-color: #fff;
        color: #326afb;
      }

      .click_but {
        background-color: #326afb;
        font-weight: 600;
        color: #fff;
      }
    }
  }

  .select_img {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }

  .contract_box {
    font-size: 14px;
    color: #333;
    display: flex;
    align-items: center;
    margin-bottom: 30px;
  }

  .select_tow_box {
    width: 100%;
    background: #e0e9ff;
    border-radius: 16px;
    color: #326afb;
    display: flex;
    align-items: center;
    font-size: 14px;
    justify-content: space-between;
    padding: 9px 15px;
    box-sizing: border-box;
    margin-bottom: 5px;
  }
  .prompt_warn {
    cursor: pointer;
    color: #f9ae3d;
    background-color: #fdf6ec;
    padding: 10px 13px;
    width: 100%;
    box-sizing: border-box;
    border-radius: 5px;
    font-size: 13px;
    margin-bottom: 10px;
  }
  .content_box {
    width: 85%;
    min-height: 150px;
    border-radius: 10px;
    margin: 0 auto;
    background-color: #fff;
    padding: 20px 15px;
    .img_box {
      position: static;

      .title {
        font-size: 15px;
        color: #333;
        font-weight: 600;
        margin-bottom: 17px;
      }

      .upload_box {
        position: relative;
        width: 100%;
        height: 179px;
        background: #e7efff;
        border-radius: 6px;
        margin-bottom: 15px;
        display: flex;
        justify-content: center;

        img {
          width: 176px;
          height: 106px;
          margin-top: 20px;
        }
        .btn {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 30px;
          line-height: 30px;
          span-align: center;
          background: #326afb;
          font-size: 15x;
          color: #fff;
          border-radius: 0 0 6px 6px;
        }
      }
    }
  }
  .input_box {
    height: 50px;
    background: #f7f8fa;
    border-radius: 10px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    margin: 0 auto 10px;
    font-size: 15px;

    > span {
      margin-right: 15px;
    }
    > input {
      flex: 1;
    }
  }
}
// 支付弹窗
.payment {
  ::v-deep .el-dialog {
    top: 50%;
    transform: translateY(-50%);
    margin-top: 0 !important;
    width: 500px;
    height: 390px;
    background: #ffffff;
    border: 0px solid #818790;
    box-shadow: 0px 0px 16px 0px rgba(98, 102, 107, 0.2);
    .el-dialog__header {
      height: 42px;
      background: #f4f6f7;
      padding: 0;
      line-height: 42px;
      .el-dialog__title {
        margin-left: 15px;
        font-size: $font-size-medium;
        font-family: PingFang SC;
        font-weight: 500;
        color: #393939;
      }
      .el-dialog__headerbtn {
        top: $font-size-small;
        right: $font-size-small;
        font-size: $font-size-large;
      }
    }
    .el-dialog__body {
      padding: 65px 20px;
      .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .notes {
          font-size: $font-size-medium;
          font-family: PingFang SC;
          font-weight: 500;
          color: $color-text-black;
        }
        .imgBox {
          width: 110px;
          height: 110px;
          margin-top: 30px;
          img {
            width: 110px;
            height: 110px;
          }
        }
      }
    }
  }
}
</style>
